export default "__VITE_ASSET__B2fcs8dt__"